/**
 * L'indirizzo base dell'API, e nient'altro.
 *
 * Vive in un file suo e non dentro `api.ts` per una ragione precisa: le pagine
 * regole vengono cotte in HTML statico dal prerender SSR
 * (`scripts/prerender.mjs` → `ssrLoadModule`), e il loro albero di moduli oggi
 * NON contiene il client API. Chi, da dentro quell'albero, importasse `API_URL`
 * da `api.ts` ci trascinerebbe dietro l'intero client e `@sentry/react` — roba
 * da browser, caricata da Node a build time, per usare una stringa.
 *
 * `api.ts` lo ri-esporta, quindi chi lo importava da li' non cambia niente.
 */
export const API_URL =
  import.meta.env.VITE_API_URL ||
  `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:3002/api`;
